define('sentient/aba/GaugeCircle',[
	'require',
	'jquery',
	'underscore',
	'loglevel',
	'domReady',
	'jquery.color'
	], function(require, $, _, log, domReady, jqueryColor) {
		log.trace('GaugeCircle.js');
		return function(elements) {
			var $elements = $(elements);

			$elements.each(function(index, element) {
				var $element = $(element);
				$element.data({
					'readoutValueElm': $element.find('.readout .value').first(),
					'endCapElm': $element.find('.end.cap').first()
				});

				var svgNS = 'http://www.w3.org/2000/svg';
				var xlinkNS = 'http://www.w3.org/1999/xlink';

				//log.debug('GaugeCircle', {"element":element});
				var document = element.ownerDocument || document;
				var svg = document.createElementNS(svgNS, 'svg');
				svg.setAttribute('xmlns', svgNS);
				svg.setAttribute('width', '100%');
				svg.setAttribute('height', '100%');
				svg.setAttribute('viewBox', '0 0 1 1');

				// Options:
				// - centerX, centerY: coordinates for the center of the circle
				// - startDegrees, endDegrees: fill between these angles, clockwise
				// - innerRadius, outerRadius: distance from the center
				// - thickness: distance between innerRadius and outerRadius
				//   You should only specify two out of three of the radii and thickness
				var annularSector = function(path, options) {
					var opts = optionsWithDefaults(options);
					var p = [ // points
						[opts.cx + opts.r2 * Math.cos(opts.startRadians),
						opts.cy + opts.r2 * Math.sin(opts.startRadians)],
						[opts.cx + opts.r2 * Math.cos(opts.closeRadians),
						opts.cy + opts.r2 * Math.sin(opts.closeRadians)],
						[opts.cx + opts.r1 * Math.cos(opts.closeRadians),
						opts.cy + opts.r1 * Math.sin(opts.closeRadians)],
						[opts.cx + opts.r1 * Math.cos(opts.startRadians),
						opts.cy + opts.r1 * Math.sin(opts.startRadians)]
					];

					var angleDiff = opts.closeRadians - opts.startRadians;
					var largeArc = (angleDiff % (Math.PI * 2)) > Math.PI ? 1 : 0;
					var cmds = [];
					cmds.push('M' + p[0].join());                                // Move to P0
					cmds.push('A' + [opts.r2, opts.r2, 0, largeArc, 1, p[1]].join()); // Arc to  P1
					cmds.push('L' + p[2].join());                                // Line to P2
					cmds.push('A' + [opts.r1, opts.r1, 0, largeArc, 0, p[3]].join()); // Arc to  P3
					cmds.push('z');                                            // Close path (Line to P0)
					path.setAttribute('d', cmds.join(' '));

					function optionsWithDefaults(o) {
						// Create a new object so that we don't mutate the original
						var o2 = {
							cx: o.centerX || 0,
							cy: o.centerY || 0,
							startRadians: (o.startDegrees || 0) * Math.PI / 180,
							closeRadians: (o.endDegrees || 0) * Math.PI / 180
						};

						var t = o.thickness !== undefined ? o.thickness : 100;
						if (o.innerRadius !== undefined) o2.r1 = o.innerRadius;
						else if (o.outerRadius !== undefined) o2.r1 = o.outerRadius - t;
						else o2.r1 = 200 - t;
						if (o.outerRadius !== undefined) o2.r2 = o.outerRadius;
						else o2.r2 = o2.r1 + t;

						if (o2.r1 < 0) o2.r1 = 0;
						if (o2.r2 < 0) o2.r2 = 0;

						return o2;
					}
				};

				var path = document.createElementNS(svgNS, 'path');
				path.setAttribute('style', 'fill:#7bc121');


				element.appendChild(svg);
				svg.appendChild(path);

				$element.data({
					'path': path,
					'annularSector': annularSector
				});

				$element.on('change', $.proxy(function($event, newValue, render) {
					//log.debug('GaugeCircle Event: change ', newValue);
					var $this = $(this);

					var path = $this.data('path');
					var annularSector = $this.data('annularSector');




					var minValue = parseInt($this.attr('data-min-value') || 0, 10);
					var maxValue = parseInt($this.attr('data-max-value') || 100, 10);

					var deg = Math.floor((newValue / maxValue) * 360);
					//log.debug('GaugeCircle $this.data("endCapElm") ', $this.data('endCapElm'),"rotate(" + deg + "deg)");
					$this.data('endCapElm').css({'transform' : 'rotate(' + deg + 'deg)'});

					var readoutValueElm = $this.data('readoutValueElm');
					//log.debug('readoutValueElm ', readoutValueElm);
					var gaugeRadius = $this.outerHeight() / 2;
					var gaugeCenter = {'x': gaugeRadius, 'y': gaugeRadius};
					if (newValue <= 0) {
					annularSector(path, {
							'centerX': 0.5,
							'centerY': 0.5,
							'startDegrees': -90,
							'endDegrees': (-98),
							'innerRadius': 0,
							'outerRadius': 0.5
						});

						readoutValueElm.text('0');
					} else if (newValue > 0 && newValue < maxValue) {
						annularSector(path, {
							'centerX': 0.5,
							'centerY': 0.5,
							'startDegrees': -90,
							'endDegrees': ((newValue / maxValue) * (360)) - 90 ,
							'innerRadius': 0,
							'outerRadius': 0.5
						});

						readoutValueElm.text(Math.floor(((newValue) / maxValue) * 100));
					} else {
						annularSector(path, {
							'centerX': 0.5,
							'centerY': 0.5,
							'startDegrees': -90,
							'endDegrees': (360 - 91),
							'innerRadius': 0,
							'outerRadius': 0.5
						});
						readoutValueElm.text('100');
					}
				},element));

				$element.on('reset', $.proxy(function($event, newValue, render) {
					var $this = $(this);

					var path = $this.data('path');
					var annularSector = $this.data('annularSector');
					annularSector(path, {
							'centerX': 0.5,
							'centerY': 0.5,
							'startDegrees': -90,
							'endDegrees': -90,
							'innerRadius': 0,
							'outerRadius': 0.5
						});

					$this.attr({
						'data-min-value': '0',
						'data-max-value': parseInt(newValue, 10).toString()
					});
					//log.debug('GaugeCircle Event: reset ', newValue);
					var readoutValueElm = $this.data('readoutValueElm');
				},element));
			});
		};
	});

